export default "__VITE_ASSET__445f100b__"